var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "OverlayDialog",
    {
      attrs: { id: _vm.id, "show-trigger": false },
      scopedSlots: _vm._u([
        {
          key: "header",
          fn: function () {
            return [
              _vm.activeView !== "offer-content"
                ? _c("Lien", {
                    attrs: {
                      id: "back-button",
                      "is-button": true,
                      "is-mini": true,
                      "is-link-arrow-back": true,
                      label: "Retour",
                    },
                    on: { click: _vm.goBack },
                  })
                : _vm._e(),
            ]
          },
          proxy: true,
        },
        {
          key: "footer",
          fn: function () {
            return [
              _vm.radioButtonOfferSelected
                ? [
                    _vm.shouldOpenRemiseInternetPopin
                      ? _c("ob1-boutons", {
                          key: "cta-remise-" + _vm.ctaRenderKey,
                          staticClass: "mx-0 px-0 w-100",
                          attrs: {
                            "is-button": true,
                            "is-primary": true,
                            label: _vm.getCtaLabel(
                              _vm.radioButtonOfferSelected
                            ),
                            "data-bs-toggle": "modal",
                            "data-bs-target": "#remise-offers-open-modal",
                            "data-offer-seo-id":
                              _vm.radioButtonOfferSelected &&
                              _vm.radioButtonOfferSelected.idSeo,
                            "data-oevent-category": "overlay_cta",
                            "data-oevent-action": _vm.getLabelToTmsFormat(
                              _vm.getCtaLabel(_vm.radioButtonOfferSelected)
                            ),
                            "data-oevent-label": _vm.getLabelToTmsFormat(
                              _vm.radioButtonOfferSelected.name
                            ),
                          },
                        })
                      : _vm.isAddOfferWithPopin
                      ? _c("offer-cta-with-device-popin", {
                          key: "cta-with-device-" + _vm.ctaRenderKey,
                          attrs: {
                            "is-wide": false,
                            "is-primary": true,
                            "from-cds": true,
                            label: _vm.getCtaLabel(
                              _vm.radioButtonOfferSelected
                            ),
                            "offer-name": _vm.radioButtonOfferSelected.name,
                            "offer-seo-id": _vm.radioButtonOfferSelected.idSeo,
                            "popin-id":
                              "addOfferWithDevicePopIn-" +
                              _vm.radioButtonOfferSelected.idSeo,
                            "popin-ctas-dto":
                              _vm.radioButtonOfferSelected.addOfferDto
                                .popinWithDeviceCdsDto,
                            "tracking-category": "overlay_forfait",
                            "tracking-label": _vm.getLabelToTmsFormat(
                              _vm.radioButtonOfferSelected.name
                            ),
                          },
                          on: {
                            "add-to-cart-success": _vm.onAddToCartSuccess,
                            "add-to-cart-error": _vm.onAddToCartError,
                          },
                        })
                      : _vm.radioButtonOfferSelected.addOfferDto
                      ? _c("ob1-boutons", {
                          key: "cta-link-" + _vm.ctaRenderKey,
                          attrs: {
                            "is-button": false,
                            "is-primary": true,
                            "is-wide": false,
                            label: _vm.getCtaLabel(
                              _vm.radioButtonOfferSelected
                            ),
                            href: _vm.radioButtonOfferSelected.addOfferDto.link,
                            "data-oevent-category": "overlay_cta",
                            "data-oevent-action": _vm.getLabelToTmsFormat(
                              _vm.getCtaLabel(_vm.radioButtonOfferSelected)
                            ),
                            "data-oevent-label": _vm.getLabelToTmsFormat(
                              _vm.radioButtonOfferSelected.name
                            ),
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.radioButtonOfferSelected.addOfferWithAuthenticationDto
                      ? _c("offer-cta-with-device-popin", {
                          key: "cta-auth-" + _vm.ctaRenderKey,
                          attrs: {
                            "is-wide": false,
                            "is-primary": true,
                            "from-cds": true,
                            label: _vm.getCtaLabel(
                              _vm.radioButtonOfferSelected
                            ),
                            "offer-name": _vm.radioButtonOfferSelected.name,
                            "offer-seo-id": _vm.radioButtonOfferSelected.idSeo,
                            "popin-id":
                              "addOfferWithAuthenticationAndDevicePopIn-" +
                              _vm.radioButtonOfferSelected.idSeo,
                            "popin-ctas-dto":
                              _vm.radioButtonOfferSelected
                                .addOfferWithAuthenticationDto
                                .popinWithDeviceCdsDto,
                            "tracking-category": "overlay_cta",
                            "tracking-label": _vm.getLabelToTmsFormat(
                              _vm.radioButtonOfferSelected.name
                            ),
                          },
                          on: {
                            "add-to-cart-success": _vm.onAddToCartSuccess,
                            "add-to-cart-error": _vm.onAddToCartError,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.radioButtonOfferSelected.addOfferInCartDto
                      ? _c("ob1-boutons", {
                          key: "cta-cart-" + _vm.ctaRenderKey,
                          staticClass: "mx-0 px-0 w-100",
                          attrs: {
                            "is-button": true,
                            "is-primary": true,
                            label:
                              _vm.radioButtonOfferSelected.addOfferInCartDto
                                .label,
                            "data-oevent-category": "tuile_forfait_vsim",
                            "data-oevent-action": "ajouter_au_panier",
                            "data-oevent-label":
                              _vm.radioButtonOfferSelected.name,
                          },
                          on: {
                            "ob1-boutons-click": function ($event) {
                              $event.preventDefault()
                              return _vm.onAddOfferInCart()
                            },
                          },
                        })
                      : _vm._e(),
                  ]
                : _vm._e(),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _vm._v(" "),
      _vm.radioButtonOfferSelected
        ? _c(
            "div",
            { key: _vm.radioButtonOfferSelected.idSeo, staticClass: "row" },
            [
              _c("div", { staticClass: "col-12 px-2 px-md-3 px-lg-3" }, [
                _vm.activeView === "offer-content"
                  ? _c("div", [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-10" }, [
                          _vm.showBanner(_vm.radioButtonOfferSelected.banner)
                            ? _c("strong", {
                                directives: [
                                  {
                                    name: "msh-html",
                                    rawName: "v-msh-html",
                                    value: _vm.radioButtonOfferSelected.banner,
                                    expression:
                                      "radioButtonOfferSelected.banner",
                                  },
                                ],
                                staticClass: "ob1-tag ob1-tag-primary mb-1",
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("h2", { staticClass: "visually-hidden" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.nameAccessibility) +
                                "\n                        "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "p",
                            {
                              staticClass: "fw-bold py-0 mb-0",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.radioButtonOfferSelected.offerType
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "h2",
                            {
                              staticClass: "h1 py-0 mb-0",
                              attrs: { "aria-hidden": "true" },
                            },
                            [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm.radioButtonOfferSelected
                                      .secondaryShortLabel
                                  ) +
                                  "\n                        "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "col-2 d-flex justify-content-end" },
                          [
                            _vm.radioButtonOfferSelected.is5G
                              ? _c("img", {
                                  staticClass: "logo-5g-popin",
                                  attrs: {
                                    src: _vm.logo5gSrc,
                                    alt: "logo 5G Orange",
                                    "aria-hidden": "true",
                                  },
                                })
                              : _vm.radioButtonOfferSelected.is5GPlus
                              ? _c("img", {
                                  staticClass: "logo-5g-popin",
                                  attrs: {
                                    src: _vm.logo5gPlusSrc,
                                    alt: "logo 5G+ Orange",
                                    "aria-hidden": "true",
                                  },
                                })
                              : _vm._e(),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-2" }, [
                        _vm.getNewSubMessage(_vm.radioButtonOfferSelected)
                          ? _c(
                              "div",
                              { staticClass: "col-12 text-gray3 fw-bold" },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(
                                      _vm.getNewSubMessage(
                                        _vm.radioButtonOfferSelected
                                      )
                                    ) +
                                    "\n                    "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            {
                              class: _vm.isShowOpenDiscountMessage
                                ? "my-1 px-1 bg-greige"
                                : "my-1 mb-0",
                            },
                            [
                              _vm.isShowOpenDiscountMessage
                                ? [
                                    _c("div", {
                                      staticClass:
                                        "fw-bold small text-dark pt-1 pb-0 pe-1",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.radioButtonOfferSelected
                                            .openDiscountMessage
                                        ),
                                      },
                                    }),
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                [
                                  _c("PriceWithDetails", {
                                    staticClass: "price-align",
                                    attrs: {
                                      price: _vm.radioButtonOfferSelected.price,
                                      "price-details-popin":
                                        _vm.radioButtonOfferSelected
                                          .priceDetailsPopin,
                                      "offer-id-seo":
                                        _vm.radioButtonOfferSelected.idSeo,
                                      "offer-name":
                                        _vm.radioButtonOfferSelected.name,
                                      "tracking-category": "popin_detail_offre",
                                      "is-embedded-details": true,
                                    },
                                    on: {
                                      "show-details": _vm.showPriceDetails,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            2
                          ),
                        ]),
                        _vm._v(" "),
                        _vm.radioButtonOfferSelected.monthlyOdrs &&
                        !_vm.radioButtonOfferSelected.priceDetailsPopin
                          ? _c("div", { staticClass: "col-12" }, [
                              _c(
                                "ul",
                                {
                                  staticClass: "row list-unstyled mb-0",
                                  attrs: {
                                    "aria-label":
                                      "Offres de réductions mensuelles du forfait",
                                  },
                                },
                                _vm._l(
                                  _vm.radioButtonOfferSelected.monthlyOdrs,
                                  function (odr, index) {
                                    return _c(
                                      "li",
                                      { key: index },
                                      [
                                        _c("InlinePromise", {
                                          key: index,
                                          attrs: {
                                            claim: {
                                              attributes: { textHtml: odr },
                                            },
                                            "is-warning": true,
                                            "compact-text": true,
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              ),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.radioButtonOfferSelected.claims &&
                        _vm.radioButtonOfferSelected.claims.length > 0
                          ? _c(
                              "div",
                              {
                                class: _vm.radioButtonOfferSelected
                                  .priceDetailsPopin
                                  ? "col-12 pt-1"
                                  : "col-12",
                              },
                              [
                                _c(
                                  "ul",
                                  {
                                    staticClass: "row list-unstyled mb-0",
                                    attrs: {
                                      "aria-label": "Avantages du forfait",
                                    },
                                  },
                                  _vm._l(
                                    _vm.radioButtonOfferSelected.claims,
                                    function (claim, index) {
                                      return _c(
                                        "li",
                                        { key: `claim-${index}` },
                                        [
                                          _c("InlinePromise", {
                                            attrs: { claim: claim },
                                          }),
                                        ],
                                        1
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.blockedUnBlockedOffer
                          ? _c(
                              "div",
                              { attrs: { id: "version-blocked-selection" } },
                              [
                                _c(
                                  "div",
                                  { staticClass: "lead fw-bold pt-2 pb-0" },
                                  [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.radioButtonOfferSelected
                                            .miniOfferCdsTypeLabel
                                        ) +
                                        "\n                        "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("ob1-radio-button-list", {
                                  attrs: {
                                    "with-column-layout": true,
                                    "radios-buttons":
                                      _vm.radioButtonBlockedUnBlockedDTO,
                                  },
                                  on: { change: _vm.onVersionChange },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _vm.radioButtonOfferSelected.alreadyInCartOfferLabel
                              ? _c("ob1-message-alerte", {
                                  attrs: {
                                    type: "success",
                                    title:
                                      _vm.radioButtonOfferSelected
                                        .alreadyInCartOfferLabel,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row mb-4" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _c(
                            "div",
                            {
                              staticClass: "accordion",
                              attrs: {
                                itemscope: "",
                                itemtype: "https://schema.org/FAQPage",
                              },
                            },
                            _vm._l(
                              _vm.radioButtonOfferSelected.detailAttributes,
                              function (detailAttribute, attributeIndex) {
                                return _c(
                                  "div",
                                  {
                                    key: `${_vm.radioButtonOfferSelected.idSeo}-${attributeIndex}`,
                                    staticClass: "card multi",
                                    attrs: {
                                      itemscope: "",
                                      itemprop: "mainEntity",
                                      itemtype: "https://schema.org/Question",
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "card-header" }, [
                                      _c(
                                        "button",
                                        {
                                          staticClass: "collapsed",
                                          attrs: {
                                            id: `faqQuestion-${_vm.radioButtonOfferSelected.idSeo}-${attributeIndex}`,
                                            "data-bs-toggle": "collapse",
                                            "data-bs-target": `#faqAnswer-${_vm.radioButtonOfferSelected.idSeo}-${attributeIndex}`,
                                            "aria-controls": `faqAnswer-${_vm.radioButtonOfferSelected.idSeo}-${attributeIndex}`,
                                            "aria-expanded": "false",
                                            type: "button",
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              staticClass:
                                                "accordion-card-title",
                                            },
                                            [
                                              _c(
                                                "p",
                                                {
                                                  staticClass:
                                                    "accordion-title mb-0",
                                                  attrs: { itemprop: "name" },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        detailAttribute.titleAttribute
                                                      )
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("p", {
                                                staticClass:
                                                  "accordion-icon mb-0",
                                                attrs: {
                                                  "aria-hidden": "true",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "collapse",
                                        attrs: {
                                          id: `faqAnswer-${_vm.radioButtonOfferSelected.idSeo}-${attributeIndex}`,
                                          "aria-labelledby": `faqQuestion-${_vm.radioButtonOfferSelected.idSeo}-${attributeIndex}`,
                                          role: "region",
                                          itemscope: "",
                                          itemprop: "acceptedAnswer",
                                          itemtype: "https://schema.org/Answer",
                                        },
                                      },
                                      [
                                        _c("div", {
                                          staticClass:
                                            "accordion-card-body standard",
                                          attrs: { itemprop: "text" },
                                          domProps: {
                                            innerHTML: _vm._s(
                                              detailAttribute.textAttribute
                                            ),
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _vm.radioButtonOfferSelected.legalMentions
                        ? _c(
                            "div",
                            { staticClass: "pb-2" },
                            [
                              _c(
                                "ob1-liens-haut-bas",
                                {
                                  attrs: {
                                    "button-id":
                                      _vm.radioButtonOfferSelected.legalMentions
                                        .title.headerId,
                                    "button-label":
                                      _vm.radioButtonOfferSelected.legalMentions
                                        .title.title,
                                    "collapsed-block-id":
                                      _vm.radioButtonOfferSelected.idSeo +
                                      "-" +
                                      _vm.radioButtonOfferSelected.legalMentions
                                        .title.textId,
                                  },
                                },
                                _vm._l(
                                  _vm.radioButtonOfferSelected.legalMentions
                                    .mentions,
                                  function (mention, index) {
                                    return _c(
                                      "div",
                                      {
                                        key:
                                          "mentiontext-" +
                                          _vm.radioButtonOfferSelected.idSeo +
                                          "-" +
                                          index,
                                      },
                                      [
                                        mention.title
                                          ? _c("strong", [
                                              _vm._v(_vm._s(mention.title)),
                                            ])
                                          : _vm._e(),
                                        _vm._v(" "),
                                        mention.text
                                          ? _c("span", {
                                              domProps: {
                                                innerHTML: _vm._s(mention.text),
                                              },
                                            })
                                          : _vm._e(),
                                      ]
                                    )
                                  }
                                ),
                                0
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.activeView === "price-content"
                  ? _c(
                      "div",
                      [
                        _c("PriceDetailsContent", {
                          attrs: {
                            id: _vm.id,
                            "offer-type": _vm.offerType,
                            "offer-name": _vm.offerName,
                            "offer-price": _vm.radioButtonOfferSelected.price,
                            "price-details":
                              _vm.radioButtonOfferSelected.priceDetailsPopin,
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }